export const FLOW_LOCK_KEY = 'moveage_flow_lock';

export const RESTORABLE_FLOWS = [
  'challenge-invite',
  'onboard-profile',
  'onboard-safety',
  'onboard-steadi',
  'research-opt-in',
  'confirm-profile',
  'instructions',
  'place',
] as const;

export type RestorableFlow = (typeof RESTORABLE_FLOWS)[number];

export interface FlowLock {
  screen: RestorableFlow;
  pendingStart: boolean;
}

function isRestorableFlow(value: string): value is RestorableFlow {
  return (RESTORABLE_FLOWS as readonly string[]).includes(value);
}

export function peekFlowLock(): FlowLock | null {
  try {
    const raw = sessionStorage.getItem(FLOW_LOCK_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as Partial<FlowLock>;
    if (!parsed || typeof parsed.screen !== 'string' || !isRestorableFlow(parsed.screen)) {
      return null;
    }
    return {
      screen: parsed.screen,
      pendingStart: parsed.pendingStart === true,
    };
  } catch {
    return null;
  }
}

export function markFlowLock(lock: FlowLock): void {
  try {
    sessionStorage.setItem(FLOW_LOCK_KEY, JSON.stringify(lock));
  } catch {
    // private mode / quota
  }
}

export function clearFlowLock(): void {
  try {
    sessionStorage.removeItem(FLOW_LOCK_KEY);
  } catch {
    // ignore
  }
}

export function isFlowLocked(): boolean {
  return peekFlowLock() !== null;
}

export function isRestorableAppState(value: string): value is RestorableFlow {
  return isRestorableFlow(value);
}

const LIVE_TEST_KEY = 'moveage_live_test';

let queuedReload: (() => void) | null = null;

export function isReloadBlocked(): boolean {
  try {
    return (
      sessionStorage.getItem(FLOW_LOCK_KEY) !== null ||
      sessionStorage.getItem(LIVE_TEST_KEY) !== null
    );
  } catch {
    return false;
  }
}

export function queueReloadWhileBlocked(reload: () => void): void {
  queuedReload = reload;
}

export function flushBlockedReload(): void {
  if (!queuedReload || isReloadBlocked()) {
    return;
  }
  const run = queuedReload;
  queuedReload = null;
  run();
}
